// extracted by mini-css-extract-plugin
export default {"modifiers":"SmallModifiers_modifiers__lYQFG","found":"SmallModifiers_found__H09St","modifier":"SmallModifiers_modifier__Gy9pO"};